import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

const HreflangUpdater = ({ slug, serverAndPort, clicked }) => {
  const cleanSlug = slug.split('?')[0];
  const usSlug = cleanSlug.startsWith('/us')
    ? cleanSlug.replace(/^\/us/, '')
    : cleanSlug;

  const hreflangs = useMemo(
    () => [
      { lang: 'en-GB', url: `${serverAndPort}${cleanSlug}` },
      { lang: 'en-US', url: `${serverAndPort}/us${usSlug}` },
    ],
    [serverAndPort, cleanSlug, usSlug]
  );

  if (!clicked) return null;

  if (typeof document !== 'undefined') {
    const existing = document.querySelectorAll(
      'link[rel="alternate"][hreflang]'
    );
    existing.forEach(tag => tag.remove());
  }

  return (
    <Helmet>
      {hreflangs.map(link => (
        <link
          key={link.lang}
          rel="alternate"
          hrefLang={link.lang}
          href={link.url}
        />
      ))}
    </Helmet>
  );
};

const mapStateToProps = state => ({
  clicked: state.hreflang.clicked,
  slug: state.app.routing.url,
  serverAndPort: state.app.serverAndPort,
});

HreflangUpdater.propTypes = {
  slug: PropTypes.string.isRequired,
  serverAndPort: PropTypes.string.isRequired,
  clicked: PropTypes.bool,
};

export default connect(mapStateToProps)(HreflangUpdater);
